import { Fragment } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslate } from 'react-polyglot';
import { observer } from 'mobx-react';

import { Header } from '../../../../bootstrap/application/components/app/Routes/layouts/CommonLayout/components/Header/Header';
import { PlayerSessionSelection } from './components/PlayerSessionSelection/PlayerSessionSelection';

export const PlayerSessionSelectionPage = observer(() => {
  const t = useTranslate();

  return (
    <Fragment>
      <Helmet>
        <title>{t('__new.play.SEO.description.title')}</title>
        <meta
          name="description"
          content={t('__new.play.SEO.description.metadescription')}
        />
      </Helmet>
      <Header />
      <PlayerSessionSelection />
    </Fragment>
  );
});
